import { CourtCasesTables } from '@app/modules/CourtCasesTables/CourtCasesTables'
import { getCourtCasesTablePath } from '@app/modules/CourtCasesTables/paths'

export const routes = [
  {
    path: getCourtCasesTablePath(),
    component: CourtCasesTables,
    exact: true
  }
]
